import { styled } from "@mui/material";
import { Link } from "react-router-dom";

const PrimaryLink = (props) => {
  return <CustomLink {...props} relative="">{props.children}</CustomLink>;
};

const CustomLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '16px',
  lineHeight: '18px'
}));

export default PrimaryLink;
